import React, { useState } from "react";
import { Login } from "../components/Login.tsx";

const LoginPage: React.FC = () => {
  const [isSigningUp, setIsSigningUp] = useState(true);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4 gap-8">
      <div className="text-center mb-6">
        <h1 className="text-3xl md:text-4xl font-bold my-3 mx-8">
          Track Your Workouts, Your Way
        </h1>
        <h2 className="text-xl md:text-2xl mx-auto max-w-screen-lg">
          Log sets, reps, and weights — for progress, maintenance, or simple
          record-keeping.
        </h2>
      </div>
      <div className="items-center space-y-4 mb-8">
        <p className="mb-2 text-center text-lg text-gray-400 italic">
          Get started in seconds
        </p>
        <Login isSigningUp={isSigningUp} setIsSigningUp={setIsSigningUp} />
      </div>
    </div>
  );
};

export { LoginPage };
